
/* eslint-disable no-case-declarations */

import _ from 'lodash'
import { Component } from 'react'
import { connect } from 'react-redux'

import Choices from '../../../../../../lib/IssueMapping/Choices'
import IssueQueuer from '../../../../../shared/IssueQueuer'
import MagicGrid from '../../../../../shared/MagicGrid'
import { Button } from '../../../../../shared/NarusMaterial'
import { CircularProgress } from '../../../../../shared/NarusMaterial/CircularProgress'
import {
  addDocument,
  closeDocument,
  createSupportingDocs,
  typeMapping
} from '../actions'

import DocumentationsForm from './DocumentationsForm'

const headers = [{
  field: 'type',
  display: 'Type'
},
{
  field: 'documented',
  display: 'Documented'
},
{
  field: 'onFile',
  display: 'On File'
}]

class DocumentGrid extends Component {
  addDocuments = data => {
    const { documents } = this.props
    const newDocs = documents.filter(d => d.type !== data.type)
    delete data.type
    newDocs.push(data)
    const result = this.flattenDocuments(newDocs)
    return result
  }

  handleSubmit = data => {
    const { currentUser, encounterId } = this.props
    this.queueIssues(data)
    const documents = this.addDocuments(data)
    this.props.dispatch(
      createSupportingDocs(
        documents,
        this.props.params.id,
        currentUser.id,
        encounterId
      )
    )
  }

  cancelForm = type => {
    this.props.dispatch(closeDocument(type))
  }

  queueIssues = data => {
    let Mapping = Choices
    switch (data.type) {
      case 'LW':
        Mapping = Choices.livingWill
        break
      case 'DNR':
        Mapping = Choices.dnr
        break
      case 'AD':
        Mapping = Choices.advancedDirective
        break
      case 'PP':
        Mapping = Choices.post
        break
      default:
        break
    }

    const iq = new IssueQueuer({
      dispatch: this.props.dispatch,
      patientId: this.props.patientId,
      practitionerId: this.props.practitionerId,
      encounterId: this.props.encounterId
    })

    iq.queueIssues({
      mapping: Mapping,
      currentForm: data,
      existingForms: this.props.documents
    })
  }

  getRows = () => {
    const { documents } = this.props
    if (documents) {
      return documents
        .map((document, index) => this.mapRow(document, index))
        .filter(row => !_.isNull(row))
    }
    return []
  }

  flattenDocuments = documents => {
    const res = {}
    documents.forEach(d => {
      Object.keys(d)
        .filter(k => k !== 'type')
        .forEach(k => {
          res[k] = d[k]
        })
    })
    return res
  }

  mapRow = (document, index) => {
    const filterEmptyRow = row =>
      (!row.documented && !row.onFile ? null : row)
    const { type } = document
    let row
    switch (type) {
      case 'LW':
        const { LWHave, LWNarusCopy } = document
        row = {
          index,
          type: typeMapping[type],
          documented: LWHave,
          onFile: LWNarusCopy,
          component: this.renderDocumentForm(type, index)
        }
        return filterEmptyRow(row)
      case 'DNR':
        const { DNRHave, DNRNarusCopy } = document
        row = {
          index,
          type: typeMapping[type],
          documented: DNRHave,
          onFile: DNRNarusCopy,
          component: this.renderDocumentForm(type, index)
        }
        return filterEmptyRow(row)
      case 'AD':
        const { ADHave, ADNarusCopy } = document
        row = {
          index,
          type: typeMapping[type],
          documented: ADHave,
          onFile: ADNarusCopy,
          component: this.renderDocumentForm(type, index)
        }
        return filterEmptyRow(row)
      case 'PP':
        const { PPHave, PPNarusCopy } = document
        row = {
          index,
          type: typeMapping[type],
          documented: PPHave,
          onFile: PPNarusCopy,
          component: this.renderDocumentForm(type, index)
        }
        return filterEmptyRow(row)
      default:
        return null
    }
  }

  renderAddButton = type => {
    const label = `Add ${typeMapping[type]}`
    return (
      <div className='form-section'>
        <Button
          grey
          label={label}
          onClick={() => {
            this.props.dispatch(addDocument(type))
          }}
        />
      </div>
    )
  }

  deleteDocument = data => {
    const { documents, currentUser, encounterId } = this.props
    documents.splice(data.index, 1)
    const newDocs = this.flattenDocuments(documents)
    this.props.dispatch(
      createSupportingDocs(
        newDocs,
        this.props.params.id,
        currentUser.id,
        encounterId
      )
    )
  }

  renderNewForm (type) {
    return this.renderDocumentForm(type)
  }

  renderDocumentForm (type, index) {
    const { documents } = this.props

    const initialValues = index || index === 0 ? documents[index] : {}

    return (
      <DocumentationsForm
        handleSubmit={this.handleSubmit}
        type={type}
        index={index}
        initialValues={initialValues}
        formKey={`documentForm${index}`}
        cancel={() => {
          this.cancelForm(type)
        }}
        remove={() => {
          this.deleteDocument(index)
        }}
      />
    )
  }

  renderButtons () {
    const { documentStats } = this.props
    const keys = Object.keys(documentStats)
    const buttons = []
    keys.forEach(k => {
      if (!documentStats[k].existing) {
        buttons.push(k)
      }
    })
    return (
      <div className='row'>
        {buttons.map(b =>
          (documentStats[b].new ? this.renderNewForm(b) : this.renderAddButton(b)))}
      </div>
    )
  }

  render () {
    if (
      this.props.loading ||
      !this.props.documents ||
      !this.props.documentStats
    ) {
      return <CircularProgress />
    }
    return (
      <div>
        <MagicGrid
          rows={this.getRows()}
          headers={headers}
          canDelete
          onDelete={this.deleteDocument}
          itemName='Documents'
        />
        {this.renderButtons()}
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  currentUser: redux.users.current_user,
  practitionerId: redux.auth.profile.sub,
  patientId: redux.globalVars.params.id,
  encounterId: _.get(redux.encounter, 'encounter.document.context_id'),
  loading: redux.supportingDocs.loading,
  documents: redux.supportingDocs.documents,
  documentStats: redux.supportingDocs.documentStats
})

export default connect(mapStateToProps)(DocumentGrid)
